/**
 * Las dos variantes que usa media interfaz: una lista que escalona a sus hijos
 * y un hijo que entra desde abajo.
 *
 * El retardo lo pone el **padre**, no el hijo. Es lo que hace que el escalonado
 * siga el orden del DOM —el orden en que se lee— y no el orden en que React
 * decidió montar los elementos, que con datos que llegan de una consulta no
 * tienen por qué coincidir.
 */
export const STAGGER = {
  hidden: {},
  shown: { transition: { staggerChildren: 0.045, delayChildren: 0.02 } },
};

export const RISE = {
  hidden: { opacity: 0, y: 10 },
  shown: { opacity: 1, y: 0, transition: { duration: 0.28, ease: [0.22, 0.8, 0.28, 1] as const } },
};
